import { render, staticRenderFns } from "./FeedbackBox.vue?vue&type=template&id=50983cd4&scoped=true&lang=pug&"
import script from "./FeedbackBox.vue?vue&type=script&lang=js&"
export * from "./FeedbackBox.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackBox.vue?vue&type=style&index=0&id=50983cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50983cd4",
  null
  
)

export default component.exports